/* JONPARTS guides: reading progress + active table-of-contents link. No dependencies. */
(() => {
  const body = document.querySelector('.jpg-body');
  if (!body) return;

  const bar = document.querySelector('.jpg-progress');
  if (bar) {
    let ticking = false;
    const update = () => {
      const rect = body.getBoundingClientRect();
      const total = rect.height - window.innerHeight * 0.6;
      const p = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
      bar.style.setProperty('--jpg-p', p.toFixed(4));
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  const links = document.querySelectorAll('[data-jpg-toc-link]');
  const headings = [...body.querySelectorAll('h2[id]')];
  if (!links.length || !headings.length || !('IntersectionObserver' in window)) return;

  const setActive = (id) => {
    links.forEach((a) => a.classList.toggle('is-active', a.dataset.jpgTocLink === id));
  };
  const visible = new Map();
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => visible.set(e.target.id, e.isIntersecting));
    const firstVisible = headings.find((h) => visible.get(h.id));
    if (firstVisible) { setActive(firstVisible.id); return; }
    const above = headings.filter((h) => h.getBoundingClientRect().top < 0);
    if (above.length) setActive(above[above.length - 1].id);
  }, { rootMargin: '-15% 0px -70% 0px' });
  headings.forEach((h) => io.observe(h));

  // Close the mobile table of contents after a jump.
  document.querySelectorAll('.jpg-toc-m a').forEach((a) => {
    a.addEventListener('click', () => { const d = a.closest('details'); if (d) d.open = false; });
  });
})();
